import { render, staticRenderFns } from "./LabelListScreen.vue?vue&type=template&id=093e69b5&"
import script from "./LabelListScreen.vue?vue&type=script&lang=ts&"
export * from "./LabelListScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports